import React, { useState, useEffect } from 'react';
import KenSelect from '../../global_components/KenSelect';
import { getDataForCourseEnrolment } from '../../Utils/apiServices';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#fff',
    marginTop: '15px',
    width: '100%',
  },
  title: {
    color: '##272727',
    fontWeight: 600,
  },
  selectTabs: {
    padding: '10px',
  },
  facultyInfoSection: {
    background: '#fff',
  },
  error: {
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      color: 'white',
      background: 'rgba(241, 75, 45, 0.2)',
    },
  },
  // criteriafilter: {
  //   display: 'flex',
  //   justifyContent: 'space-between',
  //   padding: '5px',
  // },
  // filterBy: {
  //   padding: '5px',
  // },
  errorcell: {
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      color: 'white',
      background: 'rgba(241, 75, 45, 0.2)',
    },
  },
  normal: {
    color: 'white',
    background: 'green',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '101px',
    fontWeight: '500',

    '&:hover': {
      background: 'green',
      color: 'white',
    },
  },
  accordionMain: {
    background: 'transparent',
  },
  accordionTable: {
    background: '#fff',
  },
  promoteAllBtn: {
    float: 'right',
    marginTop: '1rem',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    background: '##272727 !important',
    color: '#fff',
    borderRadius: '5px',
    marginLeft: 'auto',
  },
  searchFilter: {
    position: 'absolute',
    right: '10px',
    width: '300px',
  },
  courseList: {
    minHeight: '45px',
    background: '#fff',
    marginTop: '10px',
    marginBottom: '10px',
    width: '100%',
  },
  tableText: {
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '58%',
    transform: 'translate(-50%, -50%)',
  },
}));
const HeaderFilter = ({ setTermId, value }) => {
  const classes = useStyles();
  const userDetails = localStorage.getItem('userDetails');
  const [selectProgramOption, setProgramOption] = useState([]);
  const [studentInfo, setStudentInfo] = useState({});
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectTermOption, setTermOption] = useState([]);
  const [selectProgramPlanOption, setProgramPlanOption] = useState([]);
  const [selectSectionOption, setSectionOption] = useState([]);
  const [selectCriteriaOption, setCriteriaOption] = useState([]);
  const [selectDepartmentOption, setDepartmentOption] = useState([]);

  const [term, setTerm] = useState('');

  const handleChangeProgram = (e) => {
    setStudentInfo({ ...studentInfo, program: e.target.value });
    // For Program Plan
    const ProgramPlanOption = [];
    const dataS2 = Object.entries(
      filterData.ProgramPlanForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    dataS2[0][1].map((items) => {
      ProgramPlanOption.push({
        label: items.ProgramPlanName,
        value: items.ProgramPlanId,
      });
    });
    setTermOption([]);
    setProgramPlanOption(ProgramPlanOption);
  };
  const handleChangeProgramPlan = (e) => {
    setTermOption([]);
    setStudentInfo({ ...studentInfo, programPlan: e.target.value });
    const TermOption = [];
    const dataS = Object.entries(filterData.TermForEachProgramPlan).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        TermOption.push({
          label: items.TermName,
          value: items.TermId,
        });
      });
      setTermOption(TermOption);
    }
  };
  const handleChangeTerm = (e) => {
    setTerm(e.target.value);
    setTermId(e.target.value);
    setStudentInfo({ ...studentInfo, term: e.target.value });
    const SectionOption = [];
    const dataS = Object.entries(filterData.SectionsForEachTerm).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        SectionOption.push({
          label: items.SectionName,
          value: items.SectionName,
        });
      });
      setSectionOption(SectionOption);
    }
  };
  const handleChangeDepartment = (e) => {
    setStudentInfo({ ...studentInfo, department: e.target.value });
    const ProgramOption = [];
    const dataS = Object.entries(
      filterData.AcdemicProgramsForEachDepartment
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    dataS[0][1].map((items) => {
      ProgramOption.push({
        label: items.AcademicProgramName,
        value: items.AcademicProgramId,
      });
    });
    setProgramOption(ProgramOption);
  };

  useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    // const instituteId = '0015j00000rgtHcAAI';
    getDataForCourseEnrolment(instituteId).then((res) => {
      const DepartmentOption = [];
      res.DepartmentsList.map((item) => {
        DepartmentOption.push({
          label: item.DepartmentName,
          value: item.DepartmentId,
        });
      });

      setDepartmentOption(DepartmentOption);
      setFilterData(res);
      setLoading(false);
    });
  }, []);
  return (
    <div className={classes.courseList}>
      <Grid container xs={12} className={classes.facultyInfoSection}>
        <Grid xs={4} className={classes.selectTabs}>
          <KenSelect
            label="Institute Department"
            optionalLabel={false}
            options={selectDepartmentOption}
            value={studentInfo.department}
            defaultSearchValue={studentInfo.department || ''}
            onChange={(e) => handleChangeDepartment(e)}
            placeholder="Institute Department"
            required
          />
        </Grid>
        <Grid xs={4} className={classes.selectTabs}>
          <KenSelect
            label="Academic Program"
            optionalLabel={false}
            options={selectProgramOption}
            value={studentInfo.program}
            defaultSearchValue={studentInfo.program || ''}
            onChange={(e) => handleChangeProgram(e)}
            placeholder="Academic Program"
            required
          />
        </Grid>
        <Grid xs={4} className={classes.selectTabs}>
          <KenSelect
            label="Program Plan"
            optionalLabel={false}
            options={selectProgramPlanOption}
            value={studentInfo.programPlan}
            defaultSearchValue={studentInfo.programPlan || ''}
            onChange={(e) => handleChangeProgramPlan(e)}
            placeholder="Program Plan"
            required
          />
        </Grid>
        <Grid xs={4} className={classes.selectTabs}>
          <KenSelect
            label="Term"
            optionalLabel={false}
            options={selectTermOption}
            value={studentInfo.term}
            defaultSearchValue={studentInfo.term || ''}
            onChange={(e) => handleChangeTerm(e)}
            placeholder="Term"
            required
          />
        </Grid>
        {value === 0 && (
          <Grid xs={4} className={classes.selectTabs}>
            <KenSelect
              label="Course Offering"
              optionalLabel={false}
              options={selectTermOption}
              value={studentInfo.term}
              defaultSearchValue={studentInfo.term || ''}
              onChange={(e) => handleChangeTerm(e)}
              placeholder="Term"
              required
            />
          </Grid>
        )}
        {value === 1 && (
          <Grid xs={4} className={classes.selectTabs}>
            <KenSelect
              label="Faculty Filter"
              optionalLabel={false}
              options={selectTermOption}
              value={studentInfo.term}
              defaultSearchValue={studentInfo.term || ''}
              onChange={(e) => handleChangeTerm(e)}
              placeholder="Term"
              required
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default HeaderFilter;
